// extracted by mini-css-extract-plugin
export default {"notification":"jut__DefaultEditForm__notification","notificationIcon":"jut__DefaultEditForm__notificationIcon","notificationMessage":"jut__DefaultEditForm__notificationMessage"};